import React, { useEffect, useState, useMemo } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Moment from "react-moment";
// import { useProviderNoteContext } from "../../ProviderNoteContext";
import {
  labApi,
  useGetOrdersQuery,
  useAcknowledgeLabOrderMutation,
  usePrintLabOrderFileMutation,
  useNotifyPatientMutation,
} from "../../services/labService";
// import ICONS from "../../../../../assets/images/index.js";
import ResultListing from "./elements/resultListing";
import { toast } from "react-toastify";
// import BtnMenu from "app/components/BtnMenu";
// import { useLinkComponentDataWithNoteMutation } from "app/redux/providerNoteService";
import { cloneDeep } from "lodash";
// import { PdfViewer } from "app/components/PdfPopup/PdfViewDialog";
// import MainPageDialog from "app/components/MianPageDialog";
// import { providerNoteSlice } from "../../_redux/providerNoteSlice";
// const { actions } = providerNoteSlice;
// import { Icon } from "helpers/icons";
// import baseApiHelper from "app/redux/baseApiHelper";
// import { LoadingData } from "app/components/form/renderer";
import moment from "moment";
// import { PrintProcedures } from "../procedure_result/ProcedureTableComponent/PrintProcedure/PrintProcedures";
import { Icon } from "../../helpers/icons";
import baseApiHelper from "../../services/baseApiHelper";
import BtnMenu from "../../components/buttonDropdown";
import LoadingBars from "../../components/loadingBar";

const LabResultListing = ({
  filterAcknowledge,
  fromModule,
  viewResult,
  selectedChat,
  ...prop
}) => {
  const [allSelected, setSelectedAll] = useState(false);
//   const providerNoteContext = useProviderNoteContext();
  const dispatch = useDispatch();
  const [orderCollapse, setOrderCollapse] = useState({});
  const [pdfViewerData, setPdfViewerData] = useState({});
  const [attachmentData, setAttachmentData] = useState({});
  const [resultData, setResultData] = useState([]);
  const [dataLoadingId, setDataLoadingId] = useState(null);
  const [showFaxPopup, setShowFaxPopup] = useState({ open: false });


//   const providerNoteProps = useMemo(() => ({
//     setOpenShareLabResultsDialog:
//       providerNoteContext.setOpenShareLabResultsDialog,
//   }));

  const {
    practice: { id: practice_id },
    auth: authToken,
  } = JSON.parse(localStorage.getItem("auth"));

  const { data, isLoading } = useGetOrdersQuery({
    pid: selectedChat?.pid,
    has_result: 1,
    e10x_labs:
      fromModule == "lab_results"
        ? 0
        : fromModule == "note_lab_results"
        ? 1
        : "",
  });

  const [
    acknowledgeLabOrder, // This is the mutation trigger
  ] = useAcknowledgeLabOrderMutation();

  const [printLabOrderFile] = usePrintLabOrderFileMutation();

  const toggleLabResult = (lab_id) => {
    const val = orderCollapse[lab_id] ? false : true;
    setOrderCollapse({ ...orderCollapse, [lab_id]: val });
  };

  useEffect(() => {
    if (data && data.code == 0) {
      fetchLabsData(data.data);
    }
  }, [data]);

  const fetchLabsData = async (data) => {
    let responseData = data;
    if (filterAcknowledge) {
      responseData = responseData.filter((item) => {
        return !item.acknowledged;
      });
    }

    setResultData(responseData);
  };

  const acknowledgeLabResult = async (item) => {
    setDataLoadingId(item.id);
    const res = await acknowledgeLabOrder({
      lab_order_id: item.id,
      acknowledged: true,
      skip_auto_accept: 1,
    });
    setDataLoadingId(null);
    if (res.data.code == 0) {
      toast.success(res.data.msg);
    } else {
      toast.error(res.data.msg);
    }
  };

  const printPdfLabs = async (mode, item) => {
    const title = "Order #: " + item.order_number;
    setDataLoadingId(item.id);
    const res = await printLabOrderFile({
      mode,
      id: item.id,
      skip_auto_accept: 1,
    });
    setDataLoadingId(null);

    if (res.data.code == 0) {
      let response = { ...res.data.data };
      response.pid = selectedChat?.pid;
      response.pname = selectedChat?.patient?.name
        ? selectedChat?.patient?.name
        : "test";
      // previewPdfLabs(response, title);
      setShowFaxPopup({
        open: true,
        title: response.title,
        data: {
          ...item,
          uuid: response.file_id ? response.file_id : response.file_uuid,
        },
      });
    } else {
      toast.error(res.data.msg);
    }
  };

  const previewPdfLabs = (data, title, isResultAttachment) => {
    const pdfData = { ...data, title };
    if (isResultAttachment) {
      // This url works for images and pdf fine
      pdfData.previewPdfUrl =
        process.env.REACT_APP_API_URL_V1 +
        "/messages/read_attachment.json?uuid=" +
        data.file_id +
        "&token=" +
        authToken +
        "&tz=" +
        new Date().getTimezoneOffset();
    } else {
      //this url only works for pdfs
      if (data.file_id) {
        pdfData.previewPdfUrl = `${
          process.env.REACT_APP_API_URL_V1
        }/efax/read_document?file_name=${
          data.file_id
        }&token=${authToken}&tz=${new Date().getTimezoneOffset()}`;
        // pdfData.previewPdfWithoutToolbar = `${process.env.REACT_APP_API_URL_V1}/efax/read_document?file_name=${data.file_id}&token=${authToken}&tz=${new Date().getTimezoneOffset()}#toolbar=0&navpanes=0&scrollbar=0`;
      } else {
        pdfData.previewPdfUrl = `${
          process.env.REACT_APP_API_URL_V1
        }/efax/read_document?file_name=${
          data.file_uuid
        }&token=${authToken}&tz=${new Date().getTimezoneOffset()}`;
        // pdfData.previewPdfWithoutToolbar = `${process.env.REACT_APP_API_URL_V1}/efax/read_document?file_name=${data.file_uuid}&token=${authToken}&tz=${new Date().getTimezoneOffset()}#toolbar=0&navpanes=0&scrollbar=0`;
      }
    }

    setPdfViewerData({
      isOpen: true,
      pdfData,
      isOpenFromAttachment: isResultAttachment,
    });
  };

  const triggerPrint = () => {
    window.open(pdfViewerData.pdfData.previewPdfUrl, "_blank");
    setPdfViewerData({});
  };

  const viewAttachment = (files = []) => {
    if (files.length == 1) {
      const data = {
        ...files[0],
        title: files[0].title ? files[0].title : "Labs Attachment",
      };

      previewPdfLabs(data, data.title, true);
    } else {
      setAttachmentData({ isOpen: true, data: files });
    }
  };

  const pdfPreviewFooterList = [
    { type: "cancel", action: () => setPdfViewerData({}), title: "Cancel" },
    { type: "save", action: () => triggerPrint(), title: "Print" },
  ];

  const getResultActionBts = (lab) => {
    let buttons = [];
    if (lab.can_save_results && !lab.acknowledged) {
      buttons.push({ slug: "edit", label: "Edit" });
    }
    buttons.push({ slug: "view", label: "View" });
    // if (
    //   lab.linked_encounter == 0 ||
    //   (Array.isArray(lab.linked_encounter) &&
    //     !lab.linked_encounter?.includes(selectedNote.encounter))
    // ) {
    //   buttons.push({ slug: "add_note", label: "Add to Note" });
    // }

    // if (
    //   Array.isArray(lab.linked_encounter) &&
    //   lab.linked_encounter?.includes(selectedNote.encounter)
    // ) {
    //   buttons.push({ slug: "remove_from_note", label: "Remove from Note " });
    // }
    if (!lab?.acknowledged) {
      buttons.push({ slug: "acknowledge", label: "Review & Ack" });
    }
    if (!lab.patient_notified) {
      buttons.push({ slug: "notify_patient", label: "Notify Patient" });
    }
    if (!lab.patient_access) {
      buttons.push({
        slug: "share_on_patient_patient",
        label: "Share on Patient Portal",
      });
    }
    if (lab.patient_access) {
      buttons.push({
        slug: "share_on_patient_patient",
        label: "Remove from Patient Portal",
      });
    }
    // if(!lab?.orphan_lab){
    buttons.push({ slug: "share", label: "Share" });
    // }

    if (fromModule == "note_lab_results" || fromModule == "lab_results") {
      buttons.push({ slug: "print", label: "Print Requsition" });
      buttons.push({ slug: "print_results", label: "Print Results" });
    } else {
      buttons.push({ slug: "print", label: "Print" });
    }

    return buttons;
  };

//   const onResultAction = (opt, lab) => {
//     if (opt.slug == "acknowledge") {
//       acknowledgeLabResult(lab);
//     } else if (opt.slug == "print") {
//       printPdfLabs("order", lab);
//     } else if (opt.slug == "print_results") {
//       printPdfLabs("result", lab);
//     } else if (opt.slug == "edit") {
//       viewResult(lab, false, false, true);
//     } else if (opt.slug == "view") {
//       viewResult(lab, false, true);
//     } else if (opt.slug == "add_note" || opt.slug == "remove_from_note") {
//       linkResultWithNote(lab, opt.slug == "remove_from_note");
//     } else if (opt.slug == "notify_patient") {
//       patientNotified(lab.id);
//     } else if (opt.slug == "share_on_patient_patient") {
//       shareLabOrderOnPatientPortal(lab);
//     } else if (opt.slug == "share") {
//       providerNoteProps.setOpenShareLabResultsDialog(lab);
//     }
//   };

  const [notifyPatient] = useNotifyPatientMutation();

//   const patientNotified = (order_id) => {
//     const confirmationDialogObj = {
//       open: true,
//       title: "Notify Patient",
//       msg: "Are you sure you want to notify Patient?",
//       btnOK: {
//         text: "Yes",
//         callBackFun: () => {
//           var data = {};
//           data.id = order_id;
//           data.notes = "";
//           data.skip_auto_accept = 1;
//           notifyPatient(data).then((res) => {
//             if (res?.data?.code == 0) {
//               toast.success(res?.data?.msg);
//               baseApiHelper().invalidateTags(["labOrder"]);
//             } else if (res?.data?.msg) {
//               toast.error(res?.data?.msg);
//             }
//           });
//         },
//       },
//       btCancel: { text: "No" },
//     };

//     // dispatch(
//     //   actions.initConfirmationDialog({ data: { ...confirmationDialogObj } })
//     // );
//   };

  const [getPortalAccess] = labApi.endpoints.getPortalAccess.useLazyQuery();

  const shareLabOrderOnPatientPortal = (lab) => {
    const confirmationDialogObj = {
      open: true,
      title: `${!lab?.patient_access ? "Share" : "Unshare"} Result`,
      msg: `Are you sure you want to ${
        !lab?.patient_access ? "Share" : "Unshare"
      } this Lab Result ${
        !lab?.patient_access ? "on" : "from"
      } Patient Portal?`,
      btnOK: {
        text: "Yes",
        callBackFun: () => {
          setDataLoadingId(lab.id);
          getPortalAccess({
            lab_order_id: lab.id,
            grant: !lab?.patient_access,
            skip_auto_accept: 1,
          }).then(function (res) {
            setDataLoadingId(null);
            if (res?.data?.code == 0) {
              toast.success(res?.data?.msg);
              baseApiHelper().invalidateTags(["labOrder"]);
            } else if (res?.data?.msg) {
              toast.error(res?.data?.msg);
            }
          });
        },
      },
      btCancel: { text: "No" },
    };

    dispatch(
      actions.initConfirmationDialog({ data: { ...confirmationDialogObj } })
    );
  };

//   const [linkComponentDataWithNote] = useLinkComponentDataWithNoteMutation();

//   const linkResultWithNote = (lab, isRemoveFromNote) => {
//     let activeData = [];
//     if (selectedNote?.clinical_data?.labs) {
//       activeData = cloneDeep(selectedNote?.clinical_data?.labs);
//       activeData = activeData.split(",");
//     }

//     if (isRemoveFromNote) {
//       const foundOrderIndex = activeData.indexOf(lab?.id);
//       if (foundOrderIndex > -1) {
//         activeData.splice(foundOrderIndex, 1);
//       }
//     } else {
//       activeData.push(lab?.id);
//     }

//     activeData = activeData.join(",");

//     let data = {
//       active: activeData,
//       extracted: [],
//       slug: "labs",
//       note: { ...selectedNote },
//     };

//     setDataLoadingId(lab?.id);
//     linkComponentDataWithNote(data).then((res) => {
//       setDataLoadingId(null);
//       if (res?.data?.response?.code == 0) {
//         toast.success(res?.data?.response?.msg);
//         baseApiHelper().invalidateTags(["labOrder"]);
//       } else if (res?.data?.response?.msg) {
//         toast.error(res?.data?.response?.msg);
//       }
//     });
//   };

  const returnNewRecordBadge = (item) => {
    if (item.created) {
      const createdDate = moment(item.created);
      const todayDate = moment();
      const hoursDifference = todayDate.diff(createdDate, "hours");

      if (hoursDifference < 24) {
        return (
          <span className="bg-green-400 px-1 text-xs h-4 rounded-sm ml-1 text-black">
            New
          </span>
        );
      }
    }

    return "";
  };
  const toggleSelectItem = (item, itemIndex, e) => {
    const selected = e.target.checked;
    let modifyResultData = [...resultData];
    let modifyItem = { ...item };
    modifyItem.selected = selected;
    modifyResultData[itemIndex] = modifyItem;
    setResultData([...modifyResultData]);
    const unselected = modifyResultData?.find((item) => {
      return !item?.selected;
    });
    const all = unselected ? false : true;
    setSelectedAll(all);
    if (prop?.toggleSelectItem) {
      const selectedItems = modifyResultData?.filter((item) => item?.selected);
      prop?.toggleSelectItem(selectedItems);
    }
  };
  const toggleSelectAll = (e) => {
    const checkedAll = e.target.checked;
    let modifyResultData = [...resultData]?.map((item) => {
      return { ...item, selected: checkedAll };
    });
    setResultData([...modifyResultData]);
    setSelectedAll(checkedAll);
    if (prop?.toggleSelectAll) {
      prop?.toggleSelectAll(e);
    }
    const selectedItems = checkedAll ? resultData : [];
    if (prop?.toggleSelectItem) {
      prop?.toggleSelectItem(selectedItems);
    }
    if (prop?.toggleSelectItem) {
      prop?.toggleSelectItem(selectedItems);
    }
  };

  return (
    <div className="mb-4">
      {!isLoading && resultData?.length == 0 ? (
        <div className="flex flex-row justify-between items-center box-shadow border-color py-1.5 px-2.5">
          <div className="text-center w-full">No record found.</div>
        </div>
      ) : (
        <div
          className={`flex items-center justify-between p-2 gap-x-2 text-left ${
            prop.classes
              ? prop.classes
              : "border-l-4 bg-gray-c-150 border-left-teal-c-100-20"
          }`}
        >
          <div className="w-1/13">
            <input
              type="checkbox"
              onChange={(e) => {
                toggleSelectAll(e);
              }}
              checked={allSelected}
            />
          </div>
          <div className="w-2/12">Order Number</div>
          <div className="w-2/12">Provider</div>
          <div className="w-1/12">Lab</div>
          <div className="w-2/12">Result Received</div>
          <div className="w-1/12">Ordered On</div>
          <div className="w-2/12">Flags</div>
          {/* <div className="w-2/12 pl-12">Actions</div> */}
        </div>
      )}
      {isLoading ? <LoadingBars msg="Loading data..." /> : null}

      <div className="divide-y divide-gray-200 bg-white alternative-color border-l-4 text-left">
        {resultData?.map((lab, itemIndex) => {
          return (
            <div key={lab.id}>
              <div
                className={`flex justify-between items-center box-shadow py-1.5 px-2 gap-x-2 font-light ${
                  lab.abnormal_results && "bg-red-200"
                }`}
              >
                <div className="w-1/13">
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      toggleSelectItem(lab, itemIndex, e);
                    }}
                    checked={lab?.selected}
                  />
                </div>
                <div className="flex items-center gap-x-2 w-2/12">
                  <button onClick={() => toggleLabResult(lab.id)}>
                    <img
                    //   src={
                    //     orderCollapse[lab.id]
                    //       ? ICONS.arrowDown
                    //       : ICONS.arrowForward
                    //   }
                      className="icon-w-14 icon-h-14"
                      alt=""
                    />
                  </button>
                  <p
                    // className="cursor-pointer underline text-bgGreen hover:text-black-300"
                    // onClick={() => viewResult(lab, false, true)}
                  >
                    {lab.order_number} {returnNewRecordBadge(lab)}
                  </p>
                </div>
                <p className="w-2/12">
                  <span> {lab.ordering_provider_name}</span>
                </p>
                <p className="w-1/12">
                  <span> {lab.lab_name}</span>
                </p>
                <p className="w-2/12">
                  {lab.result_on ? (
                    <Moment format="MM/DD/YYYY">{lab.result_on}</Moment>
                  ) : (
                    "-"
                  )}
                </p>
                <p className="w-1/12">
                  <Moment format="MM/DD/YYYY">{lab.order_datetime}</Moment>
                </p>
                <p className="w-2/12 flex gap-2">
                  {/* {Array.isArray(lab.linked_encounter) &&
                  lab.linked_encounter?.includes(selectedNote.encounter) ? (
                    <span title="Result added in Note">
                      <Icon type="acknowledged" />
                    </span>
                  ) : null} */}
                  {lab.patient_notified == true ? (
                    <span title="Shared/Patient Notified">
                      <Icon type="notification" />
                    </span>
                  ) : null}
                  {lab.acknowledged == true ? (
                    <span title="Acknowledged / Reviewed">
                      <Icon type="tick" />
                    </span>
                  ) : null}
                  {lab.shared_via_email ? (
                    <span title="Shared via Email">
                      <Icon type="share_green" />
                    </span>
                  ) : null}
                  {lab.patient_access == true ? (
                    <span title="Shared on Patient Portal">
                      <Icon type="share" />
                    </span>
                  ) : null}
                </p>
                {/* <div className="flex gap-x-2 w-2/12 items-center">
                  <span
                    onClick={() => viewAttachment(lab?.ResultFiles)}
                    className="cursor-pointer w-5"
                  >
                    {lab?.ResultFiles?.length ? (
                      <Icon type="attachment" />
                    ) : null}
                  </span>
                  <BtnMenu
                    label={
                      <>
                        {dataLoadingId == lab.id ? (
                          <Icon className="ml-1" size="7" type="loading-dots" />
                        ) : (
                          <>Actions</>
                        )}
                      </>
                    }
                    options={getResultActionBts(lab)}
                    // onSelection={(opt) => onResultAction(opt, lab)}
                  />
                </div> */}
              </div>
              {orderCollapse[lab.id] ? (
                <div className="items-center p-2">
                  {lab?.LabTests?.map((test) => {
                    return <ResultListing test={test} />;
                  })}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
{/* 
      {pdfViewerData.isOpen && !attachmentData.isOpen ? (
        <MainPageDialog
          title={pdfViewerData.pdfData.title}
          onCancelHandler={() => {
            setPdfViewerData({});
          }}
          footer={true}
          footerList={pdfPreviewFooterList}
        >
          <div>
            <PdfViewer data={pdfViewerData.pdfData} />
          </div>
        </MainPageDialog>
      ) : null}

      {attachmentData.isOpen ? (
        <MainPageDialog
          title="Attachments"
          onCancelHandler={() => {
            setAttachmentData({});
          }}
          footer={false}
          modalSize="small"
          maxHeight={true}
        >
          <div className="mt-4">
            {attachmentData.data.map((file, index) => {
              const data = {
                ...file,
                title: file.title ? file.title : "Labs Attachment",
              };

              return (
                <div key={index} className="m-2">
                  <a
                    className="cursor-pointer text-blue-300 hover:text-blue-200 m-2"
                    onClick={() => previewPdfLabs(data, data.title, true)}
                  >
                    {file.file_title}
                  </a>
                </div>
              );
            })}
          </div>

          {pdfViewerData.isOpenFromAttachment ? (
            <MainPageDialog
              title={pdfViewerData.pdfData.title}
              onCancelHandler={() => {
                setPdfViewerData({});
              }}
              footer={false}
            >
              <PdfViewer data={pdfViewerData.pdfData} />
            </MainPageDialog>
          ) : null}
        </MainPageDialog>
      ) : null}

      {showFaxPopup?.open ? (
        <PrintProcedures
          title={showFaxPopup?.title}
          printLink={"utilities/get_attachment.json?attachment"}
          printData={showFaxPopup?.data}
          userUniqueId={showFaxPopup?.data}
          setShowPrintShareView={() =>
            setShowFaxPopup({ open: false, data: null })
          }
        />
      ) : null} */}
    </div>
  );
};

export default LabResultListing;
